import React, { FC, useState } from 'react';
import { Gallery } from 'listing-details/components';
import { GalleryProps } from 'shared/components/Gallery/Gallery.types';
import { PageGalleryContent } from '../ListingCard/ListingCard.styles';
import { useInView } from 'react-intersection-observer';

type GalleryLazyLoaderProps = GalleryProps & {
    lazyLoad: boolean;
    onHoverOnce: () => void;
};

const GalleryLazyLoader: FC<GalleryLazyLoaderProps> = (props) => {
    const { lazyLoad, onHoverOnce } = props;

    const [triggeredHoverTracking, setTriggerHoverTracking] = useState(true);

    const onMouseEnterHandler = () => {
        if (triggeredHoverTracking) onHoverOnce();
        setTriggerHoverTracking(false);
    };

    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '1400px'
    });

    const shouldLoadGallery = !lazyLoad || inView;

    return (
        <PageGalleryContent
            ref={ref}
            onMouseEnter={onMouseEnterHandler}
            data-testid="page-gallery-content"
        >
            {shouldLoadGallery && <Gallery {...props} />}
        </PageGalleryContent>
    );
};

export default GalleryLazyLoader;
